import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import user from "@Images/NewUI/user.png";
import male from "../../../Images/NewUI/male.webp";
import female from "../../../Images/NewUI/female.webp";

const Headerr = (props) => {
  const dashboardData = useSelector((state) => state.dashboard);
  const userDetail = useSelector((state) => state.userDetail);
  
  const [genderr, setGenderr] = useState("");
  const [nameUser, setNameUser] = useState("");

  const documentStatus = props.documentStatus || dashboardData?.documentStatus || {};

  useEffect(() => {
    if (documentStatus) {
      const firstName = documentStatus?.first_name || "";
      if (firstName) {
        setNameUser(
          firstName
            .split(' ')[0]
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase())
        );
      }
      setGenderr(documentStatus?.gender);
    }
  }, [documentStatus]);
   
  return (
    <div className="flex space-between align-center">
      <Link to="/profile_menu">
        <span className={`${props.via === "repay" ? "user_name_repay" : "user_name"}`}>
          {genderr === "female" ? (
            <img
              src={female || user}
              alt="img"
              width="35px"
              height="35px"
              style={{ borderRadius: "50%", marginRight: "11px", marginLeft: "-9px" }}
            />
          ) : (
            <img
              src={male || user}
              alt="img"
              width="35px"
              height="35px"
              style={{ borderRadius: "50%", marginRight: "11px", marginLeft: "-9px" }}
            />
          )}
          {" "}
          Hi{" "}
          <strong>
  {userDetail?.user_detail?.customusermodel?.first_name
    ? userDetail.user_detail.customusermodel.first_name
        .split(' ')[0]
        .charAt(0)
        .toUpperCase() + userDetail.user_detail.customusermodel.first_name
        .split(' ')[0]
        .slice(1)
        .toLowerCase()
    : nameUser || "User"}
</strong>

        </span>
      </Link>
     
    </div>
  );
};

export default Headerr;
